<template>
	<div class="myAccept">
		<div class="content">
			<div class="lanmu">
				<div class="status">
					<span>订单状态：</span>
					<el-checkbox-group v-model="checkList" @change="cbkChange">
					<el-checkbox label="所有订单" checked></el-checkbox>
					<el-checkbox label="进行中"></el-checkbox>

					<el-select v-model="goingStatus" size="small" value-key="value" :class="isShowGoing?'ShowGoing':'ShowGoing hide'" @change="ddlChange">
					 	<el-option key=0 label="全部" value=0></el-option>
						<el-option key=3 label="直解进行中" value=3></el-option>
						<el-option key=1 label="等待通知" value=1></el-option>
						<el-option key=2 label="已通知解封" value=2></el-option>
					</el-select>
					
					<el-checkbox label="等待验收" ></el-checkbox>
					<el-checkbox label="已结算" ></el-checkbox>
					<el-checkbox label="订单撤销" ></el-checkbox>
					</el-checkbox-group>
					<span></span>
					<el-select v-model="cancelStatus" name="cancelStatus"  size="small" value-key="value" :class="isShow?'visibility':'visibilityh'">
					 	<el-option v-for="item in cancelStatusArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<span class="word">选择订单状态查询，预加解封子订单将直接展示</span>
				</div>
				<div class="search">
					<span>筛选条件：</span>
					<el-select v-model="orderType" name="orderType" size="small" value-key="value" @change="ddlOrderType">
						<el-option v-for="item in orderTypeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>

					<el-select v-model="date" size="small" @change="select1">
						<el-option key=1 label="最近一个月" value=1></el-option>
						<el-option key=2 label="最近三个月" value=2></el-option>
					</el-select>
					
					<el-date-picker
					v-model="sDate" type="date" placeholder="选择开始日期" size="small"  value-format="yyyy-MM-dd"  format="yyyy-MM-dd">
					</el-date-picker>
					— 
					<el-date-picker
					v-model="eDate" type="date" placeholder="选择结束日期" size="small"  value-format="yyyy-MM-dd"  format="yyyy-MM-dd">
					</el-date-picker>

					<el-button type="primary" size="small" icon="el-icon-search" @click="query">查询</el-button>
				</div>
			</div>
			<div class="pub">
				<el-row>
					<el-col :span="3"><div class="grid-content bg-purple">	
						<el-select size="small" v-model="chooseResult" class="select1">
							<el-option key=1 label="订单号" value='SerialNo'></el-option>
							<el-option key=2 label="解封微信号" value='UnlockWx'></el-option>
							<el-option key=4 label="发单者" value='PubUser'></el-option>
							<el-option key=6 label="联系QQ" value='QQ'></el-option>
						</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="grid-content bg-purple">	
							<el-input v-model="searchInput" placeholder="请输入搜索内容" size="small"></el-input>
						</div>
					</el-col>
					<el-col :span="3">
						<div class="grid-content bg-purple">	
							&nbsp;&nbsp;<el-button type="primary" size="small" icon="el-icon-search" @click="search">搜索</el-button>
						</div>
					</el-col>
					<el-col :span="14"><div class="grid-content bg-purple fr"></div></el-col>
				</el-row>
			</div>

			<!--  table   -->
			<div class="table1">
				<el-table
				:data="tableData1"
				@row-click="rowClick"
				highlight-current-row
				border
				:row-class-name="tableRowClassName">
				<el-table-column type="index" label="序号" width="60" header-align="center" align="center"  ></el-table-column>
				<el-table-column prop="SerialNo" label="订单号"  width="200" align="center"></el-table-column>
				<el-table-column prop="Title" label="标题" width="279" align="center"></el-table-column>
				<el-table-column label="数量" align="center" width="90" :formatter="formatNum"></el-table-column>
				<el-table-column prop="Price" label="单价/单" width="100" align="center" ></el-table-column>
				<el-table-column prop="Premium" label="保费/单" width="100" align="center" ></el-table-column>
				<el-table-column prop="Ensure" label="保证金/单" width="110" align="center" ></el-table-column>
				<el-table-column label="状态" align="center" width="140" prop="Status" :formatter="formatStatus1"></el-table-column>
				<el-table-column label="发单者" align="center" width="200" prop="Nickname" ></el-table-column>
				</el-table>
				<div class="pagination fr">
					<el-pagination
					background
					layout="total, prev, pager, next"
					:total="totalCount1"
					prev-text="上一页"
					next-text="下一页"
					:page-size="pageSize"
					:current-page="pageIndex1"
					@current-change="handleCurrentChange1">
					</el-pagination>
				</div>
			</div>
		</div>

		<!--  订单详情列表 弹出层  -->
		<div :class="isShowWindow?'detailList-bg':'detailList-bg hide'"></div>
		<div class="detailList" :class="isShowWindow?'detailList':'detailList hide'">
			<div class="dl-top">
				<div class="dl-title fl">{{title}}</div>
				<div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
			</div>

			<div class="dl-main">
				<span>订单号:{{SerialNo}}</span>
				<span>单价:{{Price}}元/单</span>
				<span>保费:{{Premium}}元/单</span>
				<span>保证金:{{Ensure}}元/单</span>
			</div>

			<div class="dl-status">
				<ul>
					<li :class="index==0?'active':''" @click="chooseList(0)">全部订单<em></em></li>
					<li :class="index==1?'active':''" @click="chooseList(1)">未接手<em></em></li>
					<li :class="index==2?'active':''" @click="chooseList(2)">等待通知<em></em></li>
					<li :class="index==7?'active':''" @click="chooseList(7)">已通知解封<em></em></li>
					<li :class="index==3?'active':''" @click="chooseList(3)">等待验收<em></em></li>
					<li :class="index==4?'active':''" @click="chooseList(4)">撤销中<em></em></li>
					<li :class="index==5?'active':''" @click="chooseList(5)">已撤销<em></em></li>
					<li :class="index==6?'active':''" @click="chooseList(6)">已结算<em></em></li>
				</ul>
			</div>
			<div class="dl-table">
				<el-table
				:data="tableDataDetail"
				@row-click="rowClick1"
				highlight-current-row
				border
				height="280px"
				:row-class-name="tableRowClassName">
				<el-table-column type="index" label="序号" width="60" header-align="center" align="center"  ></el-table-column>
				<el-table-column prop="SerialNo" label="订单号"  width="250" align="center"></el-table-column>
				<el-table-column prop="Title" label="任务" width="229" align="center"></el-table-column>
				<el-table-column label="状态" align="center" width="230" prop="Status" :formatter="formatStatus"></el-table-column>
				<el-table-column label="订单留言" align="center" width="116" prop="UnRead" >
					<template slot-scope="scope">
						留言({{scope.row.UnRead}})
					</template>
				</el-table-column>
				</el-table>
			</div>

			<div class="pagination1 fr">
					<el-pagination
					background
					layout="total, prev, pager, next"
					:total="totalCount2"
					prev-text="上一页"
					next-text="下一页"
					:page-size="pageSize"
					:current-page="pageIndex2"
					@current-change="handleCurrentChange2">
					</el-pagination>
			</div>

			<div class="dl-footer">
				<span class="fr"><el-button type="primary" size="small" @click="showNoticeWindow">通知列表</el-button></span>
			</div>
		</div>
		<!-- 订单详情弹窗 -->
		<orderDetails :IsPub=0 :isShow="isShowDetail" :OrderType="OrderTypeDetail" :SerialNo="SerialNoDetail" @on-close="closeDetailWindow" @on-success="callbackDetailOrder"></orderDetails> 
	
		<!-- 通知列表 -->
		<noticeList :SerialNo="SerialNo" :isShow="isShowNoticeWindow" @on-close="closeNoticeWindow" ></noticeList>
	</div>
</template>
<style scoped>
	.lanmu{border:solid 1px #cccccc; height:120px;margin-top:46px;font-size: 16px;}
	.lanmu .status{  height:46px; padding-top:13px; border-bottom: dashed 1px #ccc; position: relative;}
	.lanmu .status .word{ position:absolute; right:0; padding-top:5px; }
	.lanmu .search{ height:47px;padding-top:13px; }
	.lanmu span{color:#999999; padding-right:20px; padding-left:20px;vertical-align: middle;}
	.table1,.dl-table{ cursor: pointer;}
	.el-checkbox-group{ display: inline;}
	.el-checkbox__label{font-size:16px;}
	.el-select{width:120px; }
	.el-date-editor--date{width:140px;}
	.pub{height:30px; padding:30px 0; }
	.select1{width:150px;}
	.visibility{visibility:visible;}
	.visibilityh{visibility:hidden;}
	.hide{ display: none;}
	.pagination{margin:60px 0;}
	.pagination1{margin-right:20px; margin-top:15px;}
	.operate{color:#4885f0; cursor: pointer;}
	.ShowGoing{ margin-right:30px;}

	.detailList-bg{position:fixed;width:100%;height:100%;bottom:0;background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:99; }
	.detailList{width:930px;height:630px; position: fixed; top:50%; left:50%; margin-left:-465px; margin-top:-315px;  z-index:999; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}

	.detailList .dl-main{width:885px; margin-top:30px; margin-left:22px;border:solid 1px #ccc; height:60px; line-height:60px;}
	.detailList .dl-main span{ padding-left:30px; font-size:16px; color:#444; }
	.detailList .dl-status { margin-left:22px; margin-right:22px; height:75px; line-height: 75px;font-size:16px;}
	.detailList .dl-status li{float: left;  color:#666666; margin-right:40px; cursor: pointer; }
	.detailList .dl-status li.active{ color:#5190ff; }
	.detailList .dl-status li.active em{border-bottom: solid 2px #5190ff; display:block; width:30px; margin:0 auto;}
	.detailList .dl-table{margin-left:22px; margin-right:22px; }
	.detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:100%;}
	.detailList .dl-footer span{ padding:0 22px;}
</style>
<script>
	import orderDetails from "../components/orderDetails"
	import noticeList from "../components/noticeList"
	export default {
		name: 'myAccept',
		components: {orderDetails:orderDetails,noticeList:noticeList},
		methods: {
			closeDetailWindow(val){
				this.isShowDetail=val;
			},
			cbkChange(){
				var val=this.checkList.pop();
				this.checkList=[];
				this.checkList.push(val);

				this.cancelStatus=-1;
				this.isShow=false;
				this.isShowGoing=false;
				this.goingStatus='0';
				if(val=="所有订单"){
					this.status=0;
				}else if(val=="进行中"){
					if(this.orderType==1){
						this.status="14";
						this.isShowGoing=false;
					}
					else{
						this.status="12,14";
						this.isShowGoing=true;
					}
				}else if(val=="等待验收")
					this.status="15";
				else if(val=="已结算")
					this.status="13,17";
				else if(val=="订单撤销"){
					this.isShow=true;
					this.status="16";
					this.cancelStatus=-1;
				}else{
					this.status=0;
				}
			},
			ddlChange(){
				if(this.goingStatus==0){
					this.status="12,14";
					this.orderType=0;
				}
				else if(this.goingStatus==1){
					this.status="12";
					this.orderType=2;
				}else if(this.goingStatus==2){
					this.status="14";
					this.orderType=2;
				}else {
					this.status="14";
					this.orderType=1;
				}
			},
			ddlOrderType(){
				var val=this.checkList[0];
				if(val=="进行中"){
					if(this.orderType==1){
						this.status="14";
						this.isShowGoing=false;
						this.goingStatus='3';
					}else if(this.orderType==2){
						this.status="12,14";
						this.isShowGoing=true;
						this.goingStatus='0';
					}else{
						this.isShowGoing=true;
						this.status="12,14";
						this.goingStatus='0';
					}
				}
			},
			select1(){
				if(this.date==1){
					this.lastMonth(1);
				}else{
					this.lastMonth(3);
				}
			},
			lastMonth(num){
				var date=new Date();
				this.eDate= this.dateFormat(date);
				date.setMonth(date.getMonth()-num);
				this.sDate= this.dateFormat(date);
			},
		   dateFormat(date){  
	            var strDate = date.getFullYear()+"-";
	            if(date.getMonth()<10){
	                 var s = date.getMonth()+1+"-";
	                 strDate += "0"+s;
	            }else{
	               strDate += date.getMonth()+1+"-";
	            }
	           if(date.getDate()<10){
	                 strDate += "0"+date.getDate();
	           }else{
	                 strDate += date.getDate();
	            }
	            return strDate;
      		},
			tableRowClassName({row, rowIndex}) {
				if (rowIndex % 2==0) {
				return 'warning-row';
				} else  {
				return 'success-row';
				}
			},
			formatNum(row, column, cellValue){
				if(this.isDetail==0){
					if(row.OrderType==2 && row.LimitType==2){
						return row.OrderNum;
					}else{
						return "-";
					}
				}else{
					return "-";
				}
			},
			commonStatus(status,cancelStatus,orderType){
				if(status==11)
					return '未接手';
				else if(status==12){
					return '等待通知';
				}else if(status==13){
					return "结算保费";
				}else if(status==14){
					if(orderType==1)
						return "进行中";
					else
						return "已通知解封";
				}else if(status==15){
					return "等待验收";
				}else if(status==17){
					return "已结算";
				}else{
					if(cancelStatus==-1)
						return "所有";
					else if(cancelStatus==11)
						return "申请撤销中";
					else if(cancelStatus==12)
						return "协商已处理";
					else if(cancelStatus==13)
						return "撤销已取消";
					else if(cancelStatus==14)
						return "客服介入中";
					else if(cancelStatus==15)
						return "客服已处理";
					else if(cancelStatus==16)
						return "客服强制撤销";
				}
			},
			formatStatus(row,column,cellValue){
				var status=row.Status;
				var cancelStatus=row.CancelStatus;
				return this.commonStatus(status,cancelStatus,row.OrderType);
			},
			formatStatus1(row,column,cellValue){
				if(this.isDetail==0){
					if(row.OrderType==2 && row.LimitType==2){
						return '-';
					}else{
						return this.commonStatus(row.Status,row.CancelStatus,row.OrderType);
					}
				}else{
					return this.commonStatus(row.Status,row.CancelStatus,row.OrderType);
				}
			},
			query(){
				if(!this.sDate){
					this.$message({ message: '请选择开始日期', type: 'warning'});
				}else if(!this.eDate){
					this.$message({ message: '请选择结束日期', type: 'warning'});
				}else{
					if(this.status==0)
						this.isDetail=0;
					else
						this.isDetail=1;
					this.where1='';
					this.pageIndex1=1;
					this.init();
				}
			},
			search(){
				this.pageIndex1=1;
				if(this.searchInput!=""){
					if(this.chooseResult=='SerialNo' || this.chooseResult=='QQ')
						this.where1=this.common.Encrypt(this.chooseResult+"='"+this.searchInput+"'");
					else if(this.chooseResult=='UnlockWx' || this.chooseResult=='Comment')
						this.where1=this.common.Encrypt(this.chooseResult+" like '%"+this.searchInput+"%'");
					else if(this.chooseResult=='PubUser')
					{
						if(this.searchInput.indexOf("USR")!=-1)
							this.where1=this.common.Encrypt("uid='"+this.searchInput+"'");
						else
							this.where1=this.common.Encrypt("Nickname='"+this.searchInput+"'");
					}else
						this.where1=this.common.Encrypt("SerialNo='"+this.searchInput+"'");
					this.init();
				}else{
					this.where1='';
					this.init();
				}
			},
			handleCurrentChange1(val){
				this.pageIndex1=val;
				this.init();
			},
			handleCurrentChange2(val){
				this.pageIndex2=val;
				this.ListBySerialNo();
			},
			init(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("MyPCAcceptList?UserID="+userId+"&Status="+self.status+"&CancelStatus="+self.cancelStatus+"&OrderType="+self.orderType+"&StartDate="+self.sDate+"&EndDate="+self.eDate+"&SearchTxt="+self.where1+"&PageIndex="+self.pageIndex1+"&PageSize="+self.pageSize,function(res){
						if(res.ReturnCode == 1){
							self.tableData1=res.Result;
							self.totalCount1=parseInt(res.Message);
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			ListBySerialNo(){
				const self = this;
				if(self.SerialNo!=''){
					var data= self.common.GetlocalStorage("UnLockUserData");
					var userId=JSON.parse(data).UserID;
					self.http.ajaxGet("LevelOrderDetailPCList?UserID="+userId+"&IsPub=0&SerialNo="+self.SerialNo+"&Status="+self.status1+"&CancelStatus="+self.cancelStatus1+"&PageSize="+self.pageSize+"&PageIndex="+self.pageIndex2,function(res){
							if(res.ReturnCode == 1){
								self.tableDataDetail=res.Result;
								self.totalCount2=parseInt(res.Message);
							}else{
								self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
							}	
						},function(err){
							self.$alert(err, '错误', {confirmButtonText: '确定'});
					})
				}
			},
			NoticeAjax(SerialNo,UnlockWx,stamp){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("Notice?UserID="+userId+"&SerialNo="+SerialNo+"&UnlockWx="+UnlockWx+"&Stamp="+stamp,function(res){
						if(res.ReturnCode == 1){
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定',callback:function(){
								self.init();
							}});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			NoticeOneAjax(SerialNo,UnlockWx,stamp,index){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("NoticeOne?UserID="+userId+"&SerialNo="+SerialNo+"&UnlockWx="+UnlockWx+"&Stamp="+stamp,function(res){
						if(res.ReturnCode == 1){
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定',callback:function(){
								if(index==1)
									self.init();
								else
									self.ListBySerialNo();
							}});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			chooseList(para){
				this.index=para;
				switch(para) {
					case 0:
						this.status1=0;
						this.cancelStatus1=0;
						break;
					case 1:
						this.status1=11;
						this.cancelStatus1=10;
						break;
					case 2:
						this.status1="12";
						this.cancelStatus1=10;
						break;
					case 3:
						this.status1="15";
						this.cancelStatus1=10;
						break;
					case 4:
						this.status1="16";
						this.cancelStatus1="11,14";
						break;
					case 5:
						this.status1="16";
						this.cancelStatus1="12,15,16";
						break;
					case 6:
						this.status1="13,17";
						this.cancelStatus1=10;
						break;
					case 7:
						this.status1="14";
						this.cancelStatus1=10;
						break;
					default:
						this.status1=0;
						this.cancelStatus1=0;
						break;
				}
				this.ListBySerialNo(); 
			},
			rowClick(row, event, column){
				this.title=row.Title;
				this.pageIndex2=1;
				this.SerialNo=row.SerialNo;
				this.Price=row.Price;
				this.Ensure=row.Ensure;
				this.Premium=row.Premium;
				this.index=0;
				this.status1=0;
				this.cancelStatus1=0;
				this.showNickNameQQ=false;
				this.OrderTypeDetail=row.OrderType;
				this.SerialNoDetail=row.SerialNo;
				if(this.isDetail==0){
					if(row.OrderType==1){
						//跳转到订单详情页面
						this.isShowDetail=true;
					}else{
						if(row.LimitType==1){
							//跳转到订单详情页面
							this.isShowDetail=true;
						}else{
							this.isShowWindow=true;
							this.showNickNameQQ=true;
							this.nickName=row.nickName;
							this.QQ=row.QQ;
							this.ListBySerialNo();
						}
					}
				}else{
					//跳转到订单详情页面
					this.isShowDetail=true;
				}
			},
			rowClick1(row, event, column){
				this.OrderTypeDetail=2;
				this.SerialNoDetail=row.SerialNo;
				//跳转到订单详情页面
				this.isShowDetail=true;
			},
			notice2one(serialNo,stamp,index){
				 var self=this;
				 this.$prompt('解封微信号', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputPlaceholder:'请输入您的解封微信号',
          			inputErrorMessage: '请输入您需要解封的微信号'
					}).then(({ value }) => {
						self.NoticeOneAjax(serialNo,value,stamp,index);
					}).catch(() => {
					      
				});
			},
			notice(serialNo,stamp){
				 var self=this;
				 this.$prompt('解封微信号', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputPlaceholder:'请输入您的解封微信号',
          			inputErrorMessage: '请输入您需要解封的微信号'
					}).then(({ value }) => {
						self.NoticeAjax(serialNo,value,stamp);
					}).catch(() => {
					      
				});
			},
			closeWindow(){
				this.isShowWindow=false;
			},
			callbackDetailOrder(type,OrderType){
				//订单详情操作订单的回调函数
				this.init();
				this.ListBySerialNo();
			},
			showNoticeWindow(){
				this.isShowNoticeWindow=true;
			},
			closeNoticeWindow(val){
				this.isShowNoticeWindow=val;
			}
		},
		data() {
			return {
				checkList:[],
				orderType:0,
				date:'1',
				sDate:'',
				eDate:'',
				orderTypeArr:[{value:0,label:'全部'},{value:1,label:'直接解封'},{value:2,label:'预加解封'}],
				cancelStatusArr:[{value:-1,label:"所有"},{value:11,label:"申请撤销中"},{value:12,label:"协商已处理"},{value:14,label:"客服介入中"},{value:15,label:"客服已处理"},{value:16,label:"客服强制撤销"},],
				status:0,
				cancelStatus:-1,
				isShow:false,
				chooseResult:'SerialNo',
				searchInput:'',
				tableData1:[],
				tableDataDetail:[],
				totalCount1:0,
				totalCount2:0,
				pageIndex1:1,
				pageIndex2:1,
				where1:'',
				isShowWindow:false,
				SerialNo:'',
				Price:0,
				Premium:0,
				Ensure:0,
				status1:0,
				cancelStatus1:10,
				index:0,
				nickName:'',
				QQ:'',
				showNickNameQQ:false,
				title:'',
				isDetail:0,
				isShowDetail:false,
				OrderTypeDetail:0,
				SerialNoDetail:'',
				goingStatus:'0',
				isShowGoing:false,
				isShowNoticeWindow:false
			}
		},
		computed:{
			pageSize(){
				return this.$store.getters.pageSize;
			}
		},
		mounted: function () {
			var state=this.$route.query.state;
			if(state==1){
				this.isDetail=1;
				this.status=11;
				this.checkList=[];
				this.checkList.push('未接手');
			}else if(state==2){
				this.isDetail=1;
				this.status="12,14";
				this.checkList=[];
				this.checkList.push('进行中');
			}else if(state==3){
				this.isDetail=1;
				this.status="15";
				this.checkList=[];
				this.checkList.push('等待验收');
			}else if(state==4){
				this.isDetail=1;
				this.status="16";
				this.cancelStatus=-1;
				this.isShow=true;
				this.checkList=[];
				this.checkList.push('订单撤销');
			}else{
				this.status=0;
				this.isDetail=0;
			}

			this.lastMonth(1);
			this.init();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/myAccept.vue